import { Link, useLocation } from 'react-router-dom';
import IE_logo from '../../assets/images/dark_theme_IE_logo.png';
import facebook from '../../assets/images/social_share/facebook.svg';
import twitter from '../../assets/images/social_share/twitter.svg';
import linkedin from '../../assets/images/social_share/linkedin.svg';
import instagram from '../../assets/images/social_share/instagram.svg';
import Rec from './Recipt';
import Terms from './Terms';
import { useState } from 'react';
const Footer = (props) => {
  const InConstruction = true;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const location = useLocation();

  // Check if the path starts with "/posp/training/agreement"
  const isAgreementPage =
    location.pathname.startsWith('/posp/training/agreement') ||
    location.pathname.startsWith('/posp/training/submited-agreement');

  return (
    <>
      {!isAgreementPage && (
        <footer className="w-full bg-blue-50">
          <div className="bg-blue-900">
            <div className="p-12 py-9 flex flex-col gap-y-4 md:grid md:grid-cols-4 md:gap-x-4">
              <div>
                <img
                  src={IE_logo}
                  alt="Insure Efficient"
                  className="min-w-[100px] w-full max-w-[200px] h-10 object-contain mb-4"
                />
                <span className="text-white text-xs font-bold whitespace-pre-line ">
                  {`IRDA License No. 339 
              Valid upto 26/11/2027`}
                </span>
              </div>
              <div className="text-white flex flex-col md:text-start pb-4">
                <h3 className="font-bold text-lg pb-4 md:pb-4">Company</h3>
                <Link to="/about">
                  <h4 className="text-sm py-2">About Efficient</h4>
                </Link>
                {/* <Link to="/management-team">
              <h4 className="text-sm py-2">Management Team</h4>
            </Link>
            <Link to="/efficient-team">
              <h4 className="text-sm py-2">Efficient Team</h4>
            </Link> */}
                <Link to="/career">
                  <h4 className="text-sm py-2">Careers</h4>
                </Link>
                <Link to="/contact">
                  <h4 className="text-sm py-2">Contact Us</h4>
                </Link>
              </div>
              <div className="text-white flex flex-col  md:text-start pb-4">
                <h3 className="font-bold pb-4 text-lg md:pb-4">Insurances</h3>
                <Link to="/posp/products/two-wheeler-insurance">
                  <h4 className="text-sm py-2">Two-wheeler Insurance</h4>
                </Link>
                <Link to="/posp/products/car-insurance">
                  <h4 className="text-sm py-2">Car Insurance</h4>
                </Link>
                <Link to="/posp/products/pcv-insurance">
                  <h4 className="text-sm py-2">Passanger Carring Vehicle</h4>
                </Link>
                <Link to="/posp/products/gcv-insurance">
                  <h4 className="text-sm py-2">Goods Carring Vehicle</h4>
                </Link>
                <Link
                  to={
                    InConstruction
                      ? '/under-construction'
                      : '/posp/products/health-insurance'
                  }
                >
                  <h4 className="text-sm py-2">Health Insurance</h4>
                </Link>
                <Link
                  to={
                    InConstruction
                      ? '/under-construction'
                      : '/posp/products/business-insurance'
                  }
                >
                  <h4 className="text-sm py-2">Business Insurance</h4>
                </Link>
                <Link
                  to={
                    InConstruction
                      ? '/under-construction'
                      : '/posp/products/travel-insurance'
                  }
                >
                  <h4 className="text-sm py-2">Travel Insurance</h4>
                </Link>
                <Link
                  to={
                    InConstruction
                      ? '/under-construction'
                      : '/posp/products/life-insurance'
                  }
                >
                  <h4 className="text-sm py-2">Life Insurance</h4>
                </Link>
                <Link
                  to={
                    InConstruction
                      ? '/under-construction'
                      : '/posp/products/other-products'
                  }
                >
                  <h4 className="text-sm py-2">Other products</h4>
                </Link>
              </div>
              <div className="text-white flex flex-col  md:text-start">
                <h3 className="font-semibold text-xl md:pb-4">Follow Us</h3>
                <div className="flex flex-row gap-8 justify-start mt-4 lg:px-16 md:justify-start md:mt-0 md:px-0">
                  <a href="https://www.facebook.com/InsureEfficient/">
                    <img src={facebook} alt="" />
                  </a>
                  <a href="https://www.linkedin.com/company-beta/13396723/admin/overview/">
                    <img src={linkedin} alt="" />
                  </a>
                  <a href="https://twitter.com/insureefficient">
                    <img src={twitter} alt="" />
                  </a>
                  <a href="https://www.instagram.com/InsureEfficient/">
                    <img src={instagram} alt="" />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="font-medium text-center md:px-36 px-8 py-8 text-sm">
            <p className="mb-4">
              CIN : U67200MH2005PTC372655 EFFICIENT Insurance Brokers Pvt. Ltd.,
              Registered Office Address -Office No. 28, Second Floor, Navkar
              Paradise, L T Road, Babhai Naka, Borivali West, Mumbai - 400092
            </p>
            <p>
              <Link to="/rec">
                <div
                  style={{ cursor: 'pointer' }}
                  className="text-lg font-bold text-blue-600"
                >
                  IRDAI Insurance Brokers License No. 339 Valid till 26/11/2027{' '}
                </div>
              </Link>{' '}
              <br />
              Insurance is a subject matter of solicitation. Visitors are hereby
              informed that their information submitted on the website may be
              shared with insurers. <br />
              The product information for comparison displayed on this website
              is of the insurers with whom our company has an agreement.
              Principal officer : Mr. Prasad Shinde
              (Email:principalofficer@insureefficient.com)
              <br />
              Product information is authentic and solely based on the
              information received from the Insurer.
              <br />
            </p>
          </div>
          <div className="bg-blue-900">
            <div className="flex flex-col md:flex-row justify-around">
              <p className="text-white text-center py-4">
                Copyright © 2018 InsureEFFICIENT. <br /> All rights reserved.
              </p>
              <p className="text-white text-center flex  gap-8 italic py-4 px-0">
                <Link to="/shppingpolicy">
                  <div>Shipping & Delivery Policy </div>
                </Link>
                <Link to="/privacypolicy">
                  <div>Privacy Policy</div>
                </Link>
                <Link to="/refund">
                  <div> Cancellation & Refund </div>
                </Link>
                <div>
                  {' '}
                  <a href="https://irdai.gov.in/">IRDA </a>{' '}
                </div>
                <div>
                  {' '}
                  <div onClick={() => setIsModalOpen(true)}>
                    Terms & Conditions
                  </div>
                  <Terms
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                  />
                </div>
              </p>
            </div>
          </div>
        </footer>
      )}
    </>
  );
};

// Footer.propTypes = {}

export default Footer;
